import ActionButton from '@components/ActionButton';
import Typography from '@mui/material/Typography';
import * as S from './styles';
import getPixelRatio from '@source/utils/getPixelRatio';
import router from 'next/router';
import { useEffect, useState } from 'react';

type Props = {
  picture: string;
  title: string;
  text: string;
  label: string;
  alt: string;
  typography?: 'h1' | 'h2';
  imageLeft?: boolean;
  longText?: boolean;
};

type ImageSize = {
  width: number;
  height: number;
};

const Box: React.FC<Props> = ({
  picture,
  title,
  text,
  label,
  alt = 'provisório',
  typography = 'h2',
  imageLeft,
  longText
}): JSX.Element => {
  const [imageSize, setImageSize] = useState<ImageSize | undefined>();

  useEffect(() => {
    if (window !== undefined) {
      const innerWidth = window.innerWidth;

      const mediumBreakPoint = 768;

      if (innerWidth < mediumBreakPoint) {
        const imageHeight = innerWidth / 1.2;

        setImageSize({ height: imageHeight, width: innerWidth });
        return;
      }

      const imageWidth = innerWidth / 2;

      const imageHeight = imageWidth / 1.2;

      setImageSize({ height: imageHeight, width: imageWidth });
    }
  }, []);

  const imageUrl = `assets/web/img/${picture}.jpg`;

  const redirectToWizard = () => router.push('/create-challenge');

  return (
    <>
      {imageSize?.height && (
        <S.Container height={imageSize?.height}>
          <S.ImageBox height={imageSize?.height} imageLeft={imageLeft}>
            <S.CustomImage
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              imageLeft={imageLeft}
              src={`/${imageUrl}?wdt=${getPixelRatio(imageSize.width)}`}
              loader={({ src }) => `${process.env.NEXT_PUBLIC_CDN_URL}${src}`}
              layout="fill"
              objectFit="cover"
              alt={alt}
              blurDataURL={`${process.env.NEXT_PUBLIC_CDN_URL}/${imageUrl}?wdt=150&hgt=150`}
              placeholder="blur"
            />
          </S.ImageBox>

          <S.InnerBox imageLeft={imageLeft}>
            <Typography
              variant={typography}
              sx={{
                fontSize: {
                  xs: '2rem',
                  sm: '3rem',
                  md: `${longText ? '2.4rem' : '4.8rem'}`
                },
                fontWeight: 600
              }}
            >
              {title}
            </Typography>

            <S.Text dangerouslySetInnerHTML={{ __html: text }} />

            <S.ButtonsBox>
              <ActionButton
                label={label}
                labelcolor="blue"
                style={{ width: '100%', marginBottom: '1.6rem' }}
                onClick={redirectToWizard}
              />
            </S.ButtonsBox>
          </S.InnerBox>
        </S.Container>
      )}
    </>
  );
};

export default Box;
